import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, palette, shape, custom }: Theme) => ({
    icon: {
      fontSize: 30,
      color: custom.grey[1],
    },
    radio: {
      transition: 'all 200ms',
    },
    iconWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    radioLabel: {
      margin: 0,
      borderRadius: shape.borderRadius,
      color: custom.grey[2],
      '& > span': {
        width: '100%',
        margin: '8px 0',
        marginLeft: 6,
      },
      '& > span:first-child': {
        width: 24,
        margin: 0,
        padding: 0,
        justifyContent: 'flex-start',
      },
      '&:not($disabled):hover': {
        '& $radio': {
          color: palette.primary.main,
        },
      },
    },
    radioLabelActive: {
      color: palette.primary.main,
      '& $menuItemSubtitle': {
        color: palette.primary.main,
      },
      '& $icon': {
        color: palette.primary.main,
      },
    },
    radioLabelWithMargin: {
      '& > span': {
        margin: '7px 10px 7px 6px',
      },
    },
    fieldset: {
      width: '100%',
    },
    personalDataRadioGroupRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      [breakpoints.down('sm')]: {
        flexDirection: 'column',
        flexWrap: 'wrap',
      },
    },
    personalDataRadioLabelInline: {
      display: 'inline-flex',
      flex: '0 0 auto',
      width: 'auto',
      marginRight: 24,
      whiteSpace: 'nowrap',
      '& > span': {
        width: 'auto',
      },
      [breakpoints.down('sm')]: {
        width: '100%',
        marginRight: 0,
        '& > span': {
          width: '100%',
        },
      },
    },
    error: {
      position: 'absolute',
      top: -20,
      left: -20,
      height: 'calc(100% + 40px)',
      width: 'calc(100% + 40px)',
      border: `4px solid ${custom.status.danger.contrastText}`,
      borderRadius: shape.borderRadius,
      zIndex: 1,
      '& ~ *': {
        zIndex: 2,
      },
    },
    menuItemTitle: {
      display: 'block',
      width: '100%',
    },
    menuItemSubtitle: {
      display: 'flex',
      width: '80%',
      justifyContent: 'space-between',
      color: custom.grey[2],
      fontSize: 12,
      [breakpoints.down(460)]: {
        width: '100%',
        flexWrap: 'wrap',
      },
      '& > span': {
        whiteSpace: 'nowrap',
        marginRight: 10,
      },
    },
    active: {},
    disabled: {},
  })
);
